//作废的功能禁用 末尾添加hide按钮会隐藏  去掉hide和门户鉴权功能录入保持一致按钮会显示
export enum ResourceAuthEnum {
    //预约管理(新增) 
    AP_AD = "vrm2.ap.ad",
    //预约管理(编辑)
    AP_ED = "vrm2.ap.ed",
    //预约管理(查看)
    AP_VW = "vrm2.ap.vw",
    //预约管理(作废)
    AP_CANCEL = "vrm2.ap.cancel",
    //预约管理(导出)
    AP_EX = "vrm2.ap.ex",
    //预约管理(打印)
    AP_PRINT = "vrm2.ap.print",
    //预约管理(详情-保存)
    AP_ED_SAVE = "vrm2.ap.ed.save",
    //预约管理(详情-返回)
    AP_ED_BACK = "vrm2.ap.ed.back",
    //预约管理(详情-刷新)
    AP_ED_REFRESH = "vrm2.ap.ed.refresh",
    //预约管理(详情-整单折扣)
    AP_ED_DISCOUNT_ALL = "vrm2.ap.ed.discount-all",
    //预约管理(详情-用料折扣)
    AP_ED_DISCOUNT_M = "vrm2.ap.ed.discount-m",
    //预约管理(详情-项目折扣)
    AP_ED_DISCOUNT_I = "vrm2.ap.ed.discount-i",
    //预约管理(详情-维修项目添加)
    AP_ED_ADD_I = "vrm2.ap.ed.add-i",
    //预约管理(详情-维修项目批量删除)
    AP_ED_BATCH_DEL_I = "vrm2.ap.ed.batch-del-i",
    //预约管理(详情-维修项目删除)
    AP_ED_DEL_I = "vrm2.ap.ed.del-i",
    //预约管理(详情-维修用料添加)
    AP_ED_ADD_M = "vrm2.ap.ed.add-m",
    //预约管理(详情-维修用料批量删除)
    AP_ED_BATCH_DEL_M = "vrm2.ap.ed.batch-del-m",
    //预约管理(详情-维修用料删除)
    AP_ED_DEL_M = "vrm2.ap.ed.del-m",
    //预约管理(详情-转工单核对)
    AP_ED_VERIFY = "vrm2.ap.verify",

    //工单管理(新增) 
    M_AD = "vrm2.m.ad",
    //工单管理(编辑)
    M_ED = "vrm2.m.ed",
    //工单管理(查看)
    M_VW = "vrm2.m.vw",
    //工单管理(作废)
    M_CANCEL = "vrm2.m.cancel hide",
    //工单管理(导出)
    M_EX = "vrm2.m.ex",
    //工单管理(结算单打印)
    M_PRINT = "vrm2.m.print",
    //工单管理(结算单批量打印)
    M_PRINT2 = "vrm2.m.print2",
    //维修工单管理(打印)
    M_WXPRINT = "vrm2.m.wxprint",
    //工单管理(转车间)
    M_TRANS = "vrm2.m.trans",
    //工单管理（维修出库）
    M_M_OUT = "vrm2.m.m-out",




    //工单管理(详情-保存)
    M_ED_SAVE = "vrm2.m.ed.save",
    //工单管理(详情-返回)
    M_ED_BACK = "vrm2.m.ed.back",
    //工单管理(详情-刷新)
    M_ED_REFRESH = "vrm2.m.ed.refresh",
    //工单管理(详情-整单折扣)
    M_ED_DISCOUNT_ALL = "vrm2.m.ed.discount-all",
    //工单管理(详情-用料折扣)
    M_ED_DISCOUNT_M = "vrm2.m.ed.discount-m",
    //工单管理(详情-项目折扣)
    M_ED_DISCOUNT_I = "vrm2.m.ed.discount-i",
    //工单管理(详情-维修项目添加)
    M_ED_ADD_I = "vrm2.m.ed.add-i",
    //工单管理(详情-维修项目批量删除)
    M_ED_BATCH_DEL_I = "vrm2.m.ed.batch-del-i",
    //工单管理(详情-维修项目删除)
    M_ED_DEL_I = "vrm2.m.ed.del-i",
    //工单管理(详情-维修用料添加)
    M_ED_ADD_M = "vrm2.m.ed.add-m",
    //工单管理(详情-维修用料批量删除)
    M_ED_BATCH_DEL_M = "vrm2.m.ed.batch-del-m",
    // 工单管理(详情-维修用料删除)
    M_ED_DEL_M = "vrm2.m.ed.del-m",
    // 工单管理(详情-确认结算)
    M_ED_CONFIRM_BILL = "vrm2.m.ed.confirm-bill",
    //工单管理(详情-审核)
    M_ED_CONFIRM_AUDIT = "vrm2.m.ed.audit",
    //工单管理(详情-审核中)
    M_ED_CONFIRM_AUDIT_IN = "vrm2.m.ed.audit-in",
    //工单管理(详情-终检)
    M_ED_CONFIRM_FINAL = "vrm2.m.ed.final",
    //工单管理(详情-完工)
    M_ED_CONFIRM_FINISH = "vrm2.m.ed.finish",
    //工单管理（详情-退单审核）
    M_ED_CHANGEBACK_EXAMINE = "vrm2.m.ed.changeback-examine",
    //工单管理（详情-退单审核通过）
    M_ED_CHANGEBACK_APPROVED = "vrm2.m.ed.changeback-approved",



    //工单退单（编辑）
    M_R_ED = "vrm2.m.r.ed",
    //工单退单（查看）
    M_R_VW = "vrm2.m.r.vw",
    //工单退单（作废）
    M_R_CANCEL = "vrm2.m.r.cancel hide",
    //工单退单（打印）
    M_R_PRINT = "vrm2.m.r.print",
    //工单退单（导出）
    M_R_EX = "vrm2.m.r.ex",
    //工单退单（详情-确认入库）
    M_R_ED_WAREHOUSING = "vrm2.m.r.ed.warehousing",
    //工单退单（详情-确认结算）
    M_R_ED_CONFIRM_BILL = "vrm2.m.r.ed.confirm-bill",
    //工单退单（详情-保存）
    M_R_ED_SAVE = "vrm2.m.r.ed.save",
    //工单退单(详情-整单折扣)
    M_R_ED_DISCOUNT_ALL = "vrm2.m.r.ed.discount-all",
    //工单退单(详情-用料折扣)
    M_R_ED_DISCOUNT_M = "vrm2.m.r.ed.discount-m",
    //工单退单(详情-项目折扣)
    M_R_ED_DISCOUNT_I = "vrm2.m.r.ed.discount-i",
    //工单退单(详情-维修项目添加)
    M_R_ED_ADD_I = "vrm2.m.r.ed.add-i",
    //工单退单(详情-维修项目删除)
    M_R_ED_DEL_I = "vrm2.m.r.ed.del-i",
    //工单退单(详情-维修用料添加)
    M_R_ED_ADD_M = "vrm2.m.r.ed.add-m",
    // 工单退单(详情-维修用料删除)
    M_R_ED_DEL_M = "vrm2.m.r.ed.del-m",

    // 车间派工in
    //派工列表(查看)
    DISP_LIST_VW = "vrm2.disp.list.vw",
    //派工列表(派工)
    DISP_LIST_DISP = "vrm2.disp.list.disp",
    //派工列表(完工)
    DISP_LIST_FINISH = "vrm2.disp.list.finish",
    //派工列表(维修工查看)
    DISP_LIST_VW_M = "vrm2.disp.list.vw-m",
    //派工列表(详情返回)
    DISP_LIST_BACK = "vrm2.dispatch.list.back",

    //历史工单(查看)
    DISP_HISTORY_VW = "vrm2.disp.history.vw",
    //历史工单(维修工查看)
    DISP_HISTORY_VW_M = "vrm2.disp.history.vw-m",
    //历史工单(变更维修工)
    DISP_HISTORY_CHANGE_VW_M = "vrm2.disp.history.changevw-m",
    //历史工单(详情返回)
    DISP_HISTORY_BACK = "vrm2.disp.history.back",

    // 结算列表
    // 结算列表(查看)
    BILL_LIST_VW = "vrm2.bill.list.vw",
    // 结算列表(导出)
    BILL_LIST_EX = "vrm2.bill.list.ex",
    // 结算列表(打印)
    BILL_LIST_PRINT = "vrm2.bill.list.print",
    // 结算列表(详情返回)
    BILL_LIST_BACK = "vrm2.bill.list.back",

    // 客户结算
    // 客户结算(查看)
    BILL_C_VW = "vrm2.bill.c.vw",
    // 客户结算(导出)
    BILL_C_EX = "vrm2.bill.c.ex",
    // 客户结算(打印)
    BILL_C_PRINT = "vrm2.bill.c.print",
    // 客户结算(详情返回)
    BILL_C_BACK = "vrm2.bill.c.back",

    // 厂家结算
    // 厂家结算(结算)
    BILL_M_BILL = "vrm2.bill.m.bill",
    // 厂家结算(查看)
    BILL_M_VW = "vrm2.bill.m.vw",
    // 厂家结算(导出)
    BILL_M_EX = "vrm2.bill.m.ex",
    // 厂家结算(打印)
    BILL_M_PRINT = "vrm2.bill.m.print",
    // 厂家结算(详情保存)
    BILL_M_ED_SAVE = "vrm2.bill.m.ed.save",
    // 厂家结算(详情返回)
    BILL_M_ED_BACK = "vrm2.bill.m.ed.back",
    //厂家结算(详情刷新)
    BILL_M_ED_REFRESH = "vrm2.bill.m.ed.refresh",
    //厂家结算(详情确认结算)
    BILL_M_ED_CONFIRM_BILL = "vrm2.bill.m.confirm-bill",
    //厂家结算(详情整体折扣)
    BILL_M_ED_DISCOUNT_ALL = "vrm2.bill.ed.discount-all",
    //厂家结算(维修项目添加)
    BILL_M_ED_ADD_I = "vrm2.bill.m.ed.add-i",
    //厂家结算(维修项目删除)
    BILL_M_ED_DEL_I = "vrm2.bill.m.ed.del-i",
    //厂家结算(维修项目批量删除)
    BILL_M_ED_BATCH_DEL_I = "vrm2.bill.m.ed.batch-del-i",
    //厂家结算(维修用料添加)
    BILL_M_ED_ADD_M = "vrm2.bill.m.ed.add-m",
    //厂家结算(维修用料删除)
    BILL_M_ED_DEL_M = "vrm2.bill.m.ed.del-m",
    //厂家结算(维修用料批量删除)
    BILL_M_ED_BATCH_DEL_M = "vrm2.bill.m.ed.batch-del-m",

    // 客户回访
    // 客户回访(回访)
    R_VISIT_V = "vrm2.r-visit.v",
    // 客户回访(查看)
    R_VISIT_VW = "vrm2.r-visit.vw",
    // 客户回访(导出)
    R_VISIT_EX = "vrm2.r-visit.ex",
    // 客户回访(详情-填写回访信息)
    R_VISIT_FILL = "vrm2.r-visit.fill",
    // 客户回访(详情-返回)
    R_VISIT_BACK = "vrm2.r-visit.back",

    //销售订单
    //销售订单（新增）
    S_SO_AD = "vrm2.s.so.ad",
    //销售订单（编辑）
    S_SO_ED = "vrm2.s.so.ed",
    //销售订单（查看）
    S_SO_VW = "vrm2.s.so.vw",
    //销售订单（作废）
    S_SO_CANCEL = "vrm2.s.so.cancel hide",
    //销售订单（导出）
    S_SO_EX = "vrm2.s.so.ex",
    //销售订单（详情-保存）
    S_SO_ED_SAVE = "vrm2.s.so.ed.save",
    //销售订单（详情-返回）
    S_SO_ED_BACK = "vrm2.s.so.ed.back",
    //销售订单（详情-刷新）
    S_SO_ED_REFRESH = "vrm2.s.so.ed.refresh",
    //销售订单（详情-新增配件）
    S_SO_ED_ADD_M = "vrm2.s.so.ed.add-m",
    //销售订单（详情-批量删除）
    S_SO_ED_DEL_M = "vrm2.s.so.ed.del-m",
    //销售订单（详情-下载模板）
    S_SO_ED_DLOAD = "vrm2.s.so.ed.dload",
    //销售订单（详情-导入）
    S_SO_ED_IM = "vrm2.s.so.ed.im",
    //销售订单（详情-折扣）
    S_SO_ED_DISC = "vrm2.s.so.ed.disc",
    //销售订单（详情-转销售单）
    S_SO_ED_TRANS = "vrm2.s.so.ed.trans",

    // 销售单
    //销售单(新增)
    S_S_AD = "vrm2.s.s.ad",
    //销售-直采出库打印
    S_S_ZCPRINT = "vrm2.s.s.zcprint",
    //销售单(编辑)
    S_S_ED = "vrm2.s.s.ed",
    //销售单(查看)
    S_S_VW = "vrm2.s.s.vw",
    //销售单(作废)
    S_S_CANCEL = "vrm2.s.s.cancel hide",
    //销售单(导出)
    S_S_EX = "vrm2.s.s.ex",
    //销售单(打印)
    S_S_PRINT = "vrm2.s.s.print",
    //销售单(补单)
    S_S_REPL = "vrm2.s.s.repl",
    //销售单(详情-保存)
    S_S_ED_SAVE = "vrm2.s.s.ed.save",
    //销售单(详情-返回)
    S_S_ED_BACK = "vrm2.s.s.ed.back",
    //销售单(详情-刷新)
    S_S_ED_REFRESH = "vrm2.s.s.ed.refresh",
    //销售单(详情-折扣)
    S_S_ED_DISC = "vrm2.s.s.ed.disc",
    //销售单(详情-确认结算)
    S_S_ED_CONFIRM_BILL = "vrm2.s.s.ed.confirm-bill",
    //销售单(详情-库房出库)
    S_S_ED_STOCK = "vrm2.s.s.ed.stock",
    //销售单（详情-整单退货）
    S_S_ED_RETURN_ALL = "vrm2.s.s.ed.return-all",
    //销售单(详情-新增配件)
    S_S_ED_ADD_M = "vrm2.s.s.ed.add-m",
    //销售单(详情-删除配件)
    S_S_ED_DEL_M = "vrm2.s.s.ed.del-m",
    //销售单(详情-下载模板)
    S_S_ED_DLOAD = "vrm2.s.s.ed.dload",
    //销售单(详情-导入)
    S_S_ED_IM = "vrm2.s.s.ed.im",

    //销售退货
    //销售退货(新增)
    S_R_AD = "vrm2.s.r.ad",
    //销售退货(编辑)
    S_R_ED = "vrm2.s.r.ed",
    //销售退货(查看)
    S_R_VW = "vrm2.s.r.vw",
    //销售退货(作废)
    S_R_CANCEL = "vrm2.s.r.cancel hide",
    //销售退货(导出)
    S_R_EX = "vrm2.s.r.ex",
    //销售退货(打印)
    S_R_PRINT = "vrm2.s.r.print",
    //销售退货(补单)
    S_R_REPL = "vrm2.s.r.repl",
    //销售退货(详情-保存)
    S_R_ED_SAVE = "vrm2.s.r.ed.save",
    //销售退货(详情-返回)
    S_R_ED_BACK = "vrm2.s.r.ed.back",
    //销售退货(详情-新增配件)
    S_R_ED_ADD_M = "vrm2.s.r.ed.add-m",
    //销售退货(详情-批量删除)
    S_R_ED_DEL_M = "vrm2.s.r.ed.del-m",
    //销售退货(详情-确认结算)
    S_R_ED_CONFIRM_BILL = "vrm2.s.r.ed.confirm-bill",
    //销售退货(详情-库房入库)
    S_R_ED_STOCK = "vrm2.s.r.ed.stock",



    //采购审批
    //采购审批-详情导入
    P_APPROVAL_IMPORT = "vrm2.p-approval.import",
    //采购审批-详情下载模板
    P_APPROVAL_DOWNLOADMODAL = "vrm2.p-approval.downloadModal",
    //采购审批-详情批量删除
    P_APPROVAL_REMOVE = "vrm2.p-approval.remove",
    //采购审批-详情新增配件
    P_APPROVAL_ADDGOOD = "vrm2.p-approval.addGood",
    //采购审批-主单导出
    P_APPROVAL_EXPORT = "vrm2.p-approval.export",
    //采购审批-详情返回
    P_APPROVAL_BACK = "vrm2.p-approval.back",
    //采购审批-详情转采购订单
    P_APPROVAL_TRANSFER = "vrm2.p-approval.transfer",
    //采购审批-详情审批
    P_APPROVAL_APPROVAL = "vrm2.p-approval.approval",
    //采购审批-详情提交
    P_APPROVAL_SUBMIT = "vrm2.p-approval.submit",
    //采购审批-重新询价
    P_APPROVAL_RETURNAPPROVAL = "vrm2.p-approval.returnApproval",
    //采购审批-详情保存
    P_APPROVAL_SAVE = "vrm2.p-approval.save",
    //采购审批-主单打印
    P_APPROVAL_PRINT = "vrm2.p-approval.print",
    //采购审批-流转记录
    P_APPROVAL_LOOKLOG = "vrm2.p-approval.looklog",
    //采购审批-主单查看
    P_APPROVAL_LOOK = "vrm2.p-approval.look",
    //采购审批-主单编辑
    P_APPROVAL_EDIT = "vrm2.p-approval.edit",
    //采购审批-主单新增
    P_APPROVAL_ADD = "vrm2.p-approval.add",
    //采购审批-剩余审批
    P_APPROVAL_RESIDUALAPPROVAL = "vrm2.p-approval.ResidualApproval",

    //采购询价
    //采购询价-详情供应商统计导出
    P_ENQUIRY_EXPORTSUPPLIER = "vrm2.p-enquiry.exportSupplier",
    //采购询价-详情导出
    P_ENQUIRY_EXPORTDETIALPURCHASE = "vrm2.p-enquiry.exportDetialPurchase",
    //采购询价-详情批量删除
    P_ENQUIRY_ONREMOVE = "vrm2.p-enquiry.onRemove",
    //采购询价-详情新增配件
    P_ENQUIRY_ADDGOOD = "vrm2.p-enquiry.addGood",
    //采购询价-详情返回
    P_ENQUIRY_GOBACK = "vrm2.p-enquiry.goBack",
    //采购询价-详情审批
    P_ENQUIRY_ONTRUNPO = "vrm2.p-enquiry.onTrunPo",
    //采购询价-详情保存
    P_ENQUIRY_SAVE = "vrm2.p-enquiry.save",
    //采购询价-详情发布
    P_ENQUIRY_ONSUBMIT = "vrm2.p-enquiry.onSubmit",
    //采购询价-主单打印
    P_ENQUIRY_ONPRINT = "vrm2.p-enquiry.onPrint",
    //采购询价-主单导出
    P_ENQUIRY_EXPORTPURCHASE = "vrm2.p-enquiry.exportPurchase",
    //采购询价-主单查看
    P_ENQUIRY_LOOK = "vrm2.p-enquiry.look",
    //采购询价-主单新增
    P_ENQUIRY_ADD = "vrm2.p-enquiry.add",
    //采购询价-主单编辑
    P_ENQUIRY_EDIT = "vrm2.p-enquiry.edit",
    //采购询价-详情导入
    P_ENQUIRY_UPLOADDETAIL = "vrm2.p-enquiry.uploadDetail",



    //采购报价
    //采购报价-详情导入
    P_OFFER_UPLOADDETAIL = "vrm2.p-offer.uploadDetail",
    //采购报价-详情导出
    P_OFFER_EXPORTPURCHASEOFFERDETAIL = "vrm2.p-offer.exportPurchaseOfferDetail",
    //采购报价-详情返回
    P_OFFER_GOBACK = "vrm2.p-offer.goBack",
    //采购报价-详情保存
    P_OFFER_SAVE = "vrm2.p-offer.save",
    //采购报价-详情提报
    P_OFFER_SUBMITREPORT = "vrm2.p-offer.submitReport",
    //采购报价-主单导出
    P_OFFER_EXPORTPURCHASEOFFER = "vrm2.p-offer.exportPurchaseOffer",
    //采购报价-主单打印
    P_OFFER_ONPRINT = "vrm2.p-offer.onPrint",
    //采购报价-主单查看
    P_OFFER_LOOK = "vrm2.p-offer.look",
    //采购报价-主单编辑
    P_OFFER_EDIT = "vrm2.p-offer.edit",

    //采购订单
    //采购订单(新增)
    P_PL_AD = "vrm2.p.pl.ad",
    //采购订单(编辑)
    P_PL_ED = "vrm2.p.pl.ed",
    //采购订单(查看)
    P_PL_VW = "vrm2.p.pl.vw",
    //采购订单(导出)
    P_PL_EX = "vrm2.p.pl.ex",
    //采购订单(打印)
    P_PL_PRINT = "vrm2.p.pl.print",
    //采购订单(打印)
    P_PL_GETG00DPRINT = "vrm2.p.pl.getGoodPrint",
    //导出excel
    P_PL_EXEXCEL = "vrm2.p.pl.exportExcel",
    //采购订单(新打印)
    P_PL_NEWPRINT = "vrm2.p.pl.newPrint",
    //采购订单(详情-保存)
    P_PL_ED_SAVE = "vrm2.p.pl.ed.save",
    //采购订单(详情-返回)
    P_PL_ED_BACK = "vrm2.p.pl.ed.back",
    //采购订单(详情-刷新)
    P_PL_ED_REFRESH = "vrm2.p.pl.ed.refresh",
    //采购订单(详情-新增配件)
    P_PL_ED_ADD_M = "vrm2.p.pl.ed.add-m",
    //采购订单(详情-批量删除配件)
    P_PL_ED_DEL_M = "vrm2.p.pl.ed.del-m",
    //采购订单(详情-作废配件)
    P_PL_ED_CANCEL_M = "vrm2.p.pl.ed.cancel-m",
    //采购订单(详情-下载模板)
    P_PL_ED_DLOAD = "vrm2.p.pl.ed.dload",
    //采购订单(详情-登记导入)
    P_PL_ED_IMPORTARRIVALIMPORTBACK = "vrm2.p.pl.ed.arrivalExport",
    //采购订单(详情-登记导出)
    P_PL_ED_ARRIVALEXPORT = "vrm2.p.pl.ed.importArrivalImportback",
    //采购订单(详情-导入)
    P_PL_ED_IM = "vrm2.p.pl.ed.im",
    //采购订单(详情-转采购单)
    P_PL_ED_TRANS = "vrm2.p.pl.ed.trans",

    //采购单
    //采购单(新增)
    P_P_AD = "vrm2.p.p.ad",
    //采购单(编辑)
    P_P_ED = "vrm2.p.p.ed",
    //采购单(查看)
    P_P_VW = "vrm2.p.p.vw",
    //采购单(作废)
    P_P_CANCEL = "vrm2.p.p.cancel hide",
    //采购单(导出)
    P_P_EX = "vrm2.p.p.ex",
    //采购单(补单)
    P_P_REPL = "vrm2.p.p.repl",
    //采购单(打印)
    P_P_PRINT = "vrm2.p.p.print",
    //采购单(打印)
    P_P_NOPRICEPRINT = "vrm2.p.p.noPricePrint",
    //采购单(验收单打印)
    P_P_CHECKPRINT = "vrm2.p.p.checkPrint",
    //采购单(验收台账导出)
    P_P_ACCEPTANCELEDGEREXPORT = "vrm2.p.p.AcceptanceLedgerExport",
    //采购单(详情-保存)
    P_P_ED_SAVE = "vrm2.p.p.ed.save",
    //采购单(详情-返回)
    P_P_ED_BACK = "vrm2.p.p.ed.back",
    //采购单(详情-刷新)
    P_P_ED_REFRESH = "vrm2.p.p.ed.refresh",
    //采购单(详情-折扣)
    P_P_ED_DISC = "vrm2.p.p.ed.disc",
    //采购单(详情-补单)
    P_P_ED_REPL = "vrm2.p.p.ed.repl",
    //采购单(详情-确认结算)
    P_P_ED_CONFIRM_BILL = "vrm2.p.p.ed.confirm-bill",
    //采购单(详情-库房入库)
    P_P_ED_STOCK = "vrm2.p.p.ed.stock",
    //采购单(详情-新增商品)
    P_P_ED_ADD_M = "vrm2.p.p.ed.add-m",
    //采购单(详情-删除商品)
    P_P_ED_DEL_M = "vrm2.p.p.ed.del-m",
    //采购单(详情-下载模板)
    P_P_ED_DLOAD = "vrm2.p.p.ed.dload",
    //采购单(详情-导入)
    P_P_ED_IM = "vrm2.p.p.ed.im",
    //采购单(详情-转销售单)
    P_P_ED_TRANS = "vrm2.p.p.ed.trans",


    //采购退货单
    //采购退货单(新增)
    P_R_AD = "vrm2.p.r.ad",
    //采购退货单(编辑)
    P_R_ED = "vrm2.p.r.ed",
    //采购退货单(查看)
    P_R_VW = "vrm2.p.r.vw",
    //采购退货单(作废)
    P_R_CANCEL = "vrm2.p.r.cancel hide",
    //采购退货单(导出)
    P_R_EX = "vrm2.p.r.ex",
    //采购退货单(打印)
    P_R_PRINT = "vrm2.p.r.print",
    //采购退货单(打印)
    P_R_NOPRICEPRINT = "vrm2.p.r.noPricePrint",
    //采购退货单(详情-保存)
    P_R_ED_SAVE = "vrm2.p.r.ed.save",
    //采购退货单(详情-返回)
    P_R_ED_BACK = "vrm2.p.r.ed.back",
    //采购退货单(详情-刷新)
    P_R_ED_REFRESH = "vrm2.p.r.ed.refresh",
    //采购退货单(详情-确认结算)
    P_R_ED_CONFIRM_BILL = "vrm2.p.r.ed.confirm-bill",
    //采购退货单(详情-库房出库)
    P_R_ED_STOCK = "vrm2.p.r.ed.stock",
    //采购退货单(详情-新增商品)
    P_R_ED_ADD_M = "vrm2.p.r.ed.add-m",
    //采购退货单(详情-删除商品)
    P_R_ED_DEL_M = "vrm2.p.r.ed.del-m",

    //机构管理
    //机构管理(刷新)
    ORG_ORG_REFRESH = "vrm2.org.org.refresh",
    //机构管理(同步)
    ORG_ORG_SYNC = "vrm2.org.org.sync",

    //经营实体
    //经营实体(刷新)
    ORG_ENTITY_REFRESH = "vrm2.org.entity.refresh",
    //经营实体(同步)
    ORG_ENTITY_SYNC = "vrm2.org.entity.sync",

    //站点管理
    //站点管理(新增)
    ORG_SHOP_AD = "vrm2.org.shop.ad",
    //站点管理(编辑)
    ORG_SHOP_ED = "vrm2.org.shop.ed",

    //供应商档案
    //供应商档案(新增)
    DATA_S_AD = "vrm2.data.s.ad",
    //供应商档案(编辑)
    DATA_S_ED = "vrm2.data.s.ed",
    //供应商档案(查看)
    DATA_S_VW = "vrm2.data.s.vw",
    //供应商档案(导出)
    DATA_S_EX = "vrm2.data.s.ex",
    //供应商档案(导入)
    DATA_S_IM = "vrm2.data.s.im",
    //供应商档案(下载模板)
    DATA_S_DLOAD = "vrm2.data.s.dload",
    //供应商档案(启用/禁用)
    DATA_S_ABLE = "vrm2.data.s.able",
    //供应商档案(详情-保存)
    DATA_S_ED_SAVE = "vrm2.data.s.ed.save",
    //供应商档案(详情-重置)
    DATA_S_ED_RESET = "vrm2.data.s.ed.reset",
    //供应商档案(详情-取消)
    DATA_S_ED_BACK = "vrm2.data.s.ed.back",

    //配件档案
    //配件档案(新增)
    DATA_M_AD = "vrm2.data.m.ad",
    //配件档案(编辑)
    DATA_M_ED = "vrm2.data.m.ed",
    //配件档案(查看)
    DATA_M_VW = "vrm2.data.m.vw",
    //配件档案(导出)
    DATA_M_EX = "vrm2.data.m.ex",
    //配件档案(导入)
    DATA_M_IM = "vrm2.data.m.im",
    //配件档案(下载模板)
    DATA_M_DLOAD = "vrm2.data.m.dload",
    //询价截止
    DATA_M_ENQUIRYEND = "vrm2.data.m.enquiryend",
    //配件档案(启用/禁用)
    DATA_M_ABLE = "vrm2.data.m.able",
    //配件档案(详情-保存)
    DATA_M_ED_SAVE = "vrm2.data.m.ed.save",
    //配件档案(详情-重置)
    DATA_M_ED_RESET = "vrm2.data.m.ed.reset",
    //配件档案(详情-取消)
    DATA_M_ED_BACK = "vrm2.data.m.ed.back",

    //仓库管理
    //仓库管理(新增)
    DATA_W_AD = "vrm2.data.w.ad",
    //仓库管理(编辑)
    DATA_W_ED = "vrm2.data.w.ed",
    //仓库管理(详情-保存)
    DATA_W_ED_SAVE = "vrm2.data.w.ed.save",
    //仓库管理(详情-重置)
    DATA_W_ED_RESET = "vrm2.data.w.ed.reset",
    //仓库管理(详情-保存)
    DATA_W_ED_BACK = "vrm2.data.w.ed.back",

    //仓库管理(详情-区域信息)
    DATA_W_ED_AREA = "vrm2.data.w.ed.area",
    //仓库管理(详情-区域新增)
    DATA_W_ED_AREA_AD = "vrm2.data.w.ed.area.ad",
    //仓库管理(详情-区域编辑)
    DATA_W_ED_AREA_ED = "vrm2.data.w.ed.area.ed",
    //仓库管理(详情-区域导入)
    DATA_W_ED_AREA_IM = "vrm2.data.w.ed.area.im",
    //仓库管理(详情-区域下载模板)
    DATA_W_ED_AREA_DLOAD = "vrm2.data.w.ed.area.dload",

    //仓库管理(详情-货架信息)
    DATA_W_ED_SHELVES = "vrm2.data.w.ed.shelves",
    //仓库管理(详情-货架新增)
    DATA_W_ED_SHELVES_AD = "vrm2.data.w.ed.shelves.ad",
    //仓库管理(详情-货架编辑)
    DATA_W_ED_SHELVES_ED = "vrm2.data.w.ed.shelves.ed",
    //仓库管理(详情-货架导入)
    DATA_W_ED_SHELVES_IM = "vrm2.data.w.ed.shelves.im",
    //仓库管理(详情-货架下载模板)
    DATA_W_ED_SHELVES_DLOAD = "vrm2.data.w.ed.shelves.dload",

    //仓库管理(详情-货位信息)
    DATA_W_ED_SHELF = "vrm2.data.w.ed.shelf",
    //仓库管理(详情-货位新增)
    DATA_W_ED_SHELF_AD = "vrm2.data.w.ed.shelf.ad",
    //仓库管理(详情-货位编辑)
    DATA_W_ED_SHELF_ED = "vrm2.data.w.ed.shelf.ed",
    //仓库管理(详情-货位导入)
    DATA_W_ED_SHELF_IM = "vrm2.data.w.ed.shelf.im",
    //仓库管理(详情-货位下载模板)
    DATA_W_ED_SHELF_DLOAD = "vrm2.data.w.ed.shelf.dload",

    //数据字典
    //增加同级
    DATA_DIC_SUB = "vrm2.data.dic.sub",
    //增加下级
    DATA_DIC_BRO = "vrm2.data.dic.bro",
    //同级保存
    DATA_DIC_SUB_SAVE = "vrm2.data.dic.sub.save",
    //下级保存
    DATA_DIC_BRO_SAVE = "vrm2.data.dic.bro.save",
    //编辑保存
    DATA_DIC_ED_SAVE = "vrm2.data.dic.ed.save",
    //同级取消
    DATA_DIC_SUB_BACK = "vrm2.data.dic.sub.back",
    //下级取消
    DATA_DIC_BRO_BACK = "vrm2.data.dic.bro.back",
    //编辑取消
    DATA_DIC_ED_BACK = "vrm2.data.dic.ed.back",

    //客户管理
    //客户管理(新增)
    DATA_C_C_AD = "vrm2.data.c.c.ad",
    //客户管理(编辑)
    DATA_C_C_ED = "vrm2.data.c.c.ed",
    //客户管理(查看)
    DATA_C_C_VW = "vrm2.data.c.c.vw",
    //客户管理(导出)
    DATA_C_C_EX = "vrm2.data.c.c.ex",
    //客户管理(导入)
    DATA_C_C_IM = "vrm2.data.c.c.im",
    //客户管理(下载模板)
    DATA_C_C_DLOAD = "vrm2.data.c.c.dload",
    //客户管理(下属车辆)
    DATA_C_C_VEHICLE = "vrm2.data.c.c.vehicle",
    //客户管理(详情-保存)
    DATA_C_C_ED_SAVE = "vrm2.data.c.c.ed.save",
    //客户管理(详情-重置)
    DATA_C_C_ED_RESET = "vrm2.data.c.c.ed.reset",
    //客户管理(详情-取消)
    DATA_C_C_ED_BACK = "vrm2.data.c.c.ed.back",

    // 车辆管理
    //车辆管理(新增)
    DATA_C_V_AD = "vrm2.data.c.v.ad",
    //车辆管理(编辑)
    DATA_C_V_ED = "vrm2.data.c.v.ed",
    //车辆管理(查看)
    DATA_C_V_VW = "vrm2.data.c.v.vw",
    //车辆管理(导出)
    DATA_C_V_EX = "vrm2.data.c.v.ex",
    //车辆管理(导入)
    DATA_C_V_IM = "vrm2.data.c.v.im",
    //车辆管理(下载模板)
    DATA_C_V_DLOAD = "vrm2.data.c.v.dload",
    //车辆管理(返回客户)
    DATA_C_V_BACK_C = "vrm2.data.c.v.back-c",
    //车辆管理(详情-保存)
    DATA_C_V_ED_SAVE = "vrm2.data.c.v.ed.save",
    //车辆管理(详情-重置)
    DATA_C_V_ED_RESET = "vrm2.data.c.v.ed.reset",
    //车辆管理(详情-取消)
    DATA_C_V_ED_BACK = "vrm2.data.c.v.ed.back",

    // 维修项目
    //维修项目(新增)
    DATA_I_AD = "vrm2.data.i.ad",
    //维修项目(编辑)
    DATA_I_ED = "vrm2.data.i.ed",
    //维修项目(查看)
    DATA_I_VW = "vrm2.data.i.vw",
    //维修项目(导出)
    DATA_I_EX = "vrm2.data.i.ex",
    //维修项目(导入)
    DATA_I_IM = "vrm2.data.i.im",
    //维修项目(下载模板)
    DATA_I_DLOAD = "vrm2.data.i.dload",
    //维修项目(详情-保存)
    DATA_I_ED_SAVE = "vrm2.data.i.ed.save",
    //维修项目(详情-重置)
    DATA_I_ED_RESET = "vrm2.data.i.ed.reset",
    //维修项目(详情-取消)
    DATA_I_ED_BACK = "vrm2.data.i.ed.back",

    // 维修技师
    //维修技师(新增)
    DATA_T_AD = "vrm2.data.t.ad",
    //维修技师(编辑)
    DATA_T_ED = "vrm2.data.t.ed",
    //维修技师(查看)
    DATA_T_VW = "vrm2.data.t.vw",
    //维修技师(导出)
    DATA_T_EX = "vrm2.data.t.ex",
    //维修技师(导入)
    DATA_T_IM = "vrm2.data.t.im",
    //维修技师(详情-保存)
    DATA_T_ED_SAVE = "vrm2.data.t.ed.save",
    //维修技师(详情-重置)
    DATA_T_ED_RESET = "vrm2.data.t.ed.reset",
    //维修技师(详情-取消)
    DATA_T_ED_BACK = "vrm2.data.t.ed.back",

    // 库存统计
    //采购明细(转移货位)
    ST_PO_TRANS = "vrm2.st.po.trans",
    // 库存统计(导出)
    ST_INVENT_EX = "vrm2.st.invent.ex",
    //库存盘点
    //库存盘点(新增)
    ST_STTAKE_AD = "vrm2.st.sttake.ad",
    //库存盘点(编辑)
    ST_STTAKE_ED = "vrm2.st.sttake.ed",
    //库存盘点(查看)
    ST_STTAKE_VW = "vrm2.st.sttake.vw",
    //库存盘点(导出)
    ST_STTAKE_EX = "vrm2.st.sttake.ex",
    //库存盘点(作废)
    ST_STTAKE_CANCEL = "vrm2.st.sttake.cancel hide",
    //库存盘点(打印)
    ST_STTAKE_PRINT = "vrm2.st.sttake.print",
    //库存盘点(详情-保存)
    ST_STTAKE_ED_SAVE = "vrm2.st.sttake.ed.save",
    //库存盘点(详情-取消)
    ST_STTAKE_ED_BACK = "vrm2.st.sttake.ed.back",
    //库存盘点(详情-新增配件)
    ST_STTAKE_ED_ADD_M = "vrm2.st.sttake.ed.add-m",
    //库存盘点(详情-删除配件)
    ST_STTAKE_ED_EDL_M = "vrm2.st.sttake.ed.del-m",
    //库存盘点(详情-导入)
    ST_STTAKE_ED_IM = "vrm2.st.sttake.ed.im",
    //库存盘点(详情-导出)
    ST_STTAKE_ED_EX = "vrm2.st.sttake.ed.ex",
    //库存盘点(详情-盘点完成)
    ST_STTAKE_ED_FINISH = "vrm2.st.sttake.ed.finish",
    //库存盘点(详情-审核)
    ST_STTAKE_ED_EXAMINE = "vrm2.st.sttake.ed.examine",
    //维修出库

    //维修出库(编辑)
    ST_M_OUT_ED = "vrm2.st.m-out.ed",
    //维修出库(查看)
    ST_M_OUT_VW = "vrm2.st.m-out.vw",
    //维修出库(导出)
    ST_M_OUT_EX = "vrm2.st.m-out.ex",
    //维修出库(详情-保存)
    ST_M_OUT_ED_SAVE = "vrm2.st.m-out.ed.save",
    //维修出库(详情-重置)
    ST_M_OUT_ED_RESET = "vrm2.st.m-out.ed.reset",
    //维修出库(详情-取消)
    ST_M_OUT_ED_BACK = "vrm2.st.m-out.ed.back",
    //维修出库(详情-开始备料)
    ST_M_OUT_ED_PREPARE_M_S = "vrm2.st.m-out.ed.prepare-m.s",
    //维修出库(详情-备料完成)
    ST_M_OUT_ED_PREPARE_M_F = "vrm2.st.m-out.ed.prepare-m.f",
    //维修出库(详情-出库)
    ST_M_OUT_ED_PINK_M = "vrm2.st.m-out.ed.pick-m",
    //维修出库(详情-退料)
    ST_M_OUT_ED_RETURN_M = "vrm2.st.m-out.ed.return-m",

    //维修借件
    //维修借件(新增)
    ST_M_BORROW_AD = "vrm2.st.m-borrow.ad",
    //维修借件(编辑)
    ST_M_BORROW_ED = "vrm2.st.m-borrow.ed",
    //维修借件(详情-保存)
    ST_M_BORROW_ED_SAVE = "vrm2.st.m-borrow.ed.save",
    //维修借件(详情-重置)
    ST_M_BORROW_ED_RESET = "vrm2.st.m-borrow.ed.refresh",
    //维修借件(详情-取消)
    ST_M_BORROW_ED_BACK = "vrm2.st.m-borrow.ed.back",
    //维修借件(详情-新增配件)
    ST_M_BORROW_ED_ADD_M = "vrm2.st.m-borrow.ed.add-m",
    //维修借件(详情-删除配件)
    ST_M_BORROW_ED_EDL_M = "vrm2.st.m-borrow.ed.del-m",
    // 维修借件(导出)
    ST_M_BORROW_EX = "vrm2.st.m-borrow.ex",
    // 维修借件(打印)
    ST_M_BORROW_PRINT = "vrm2.st.m-borrow.print",


    //出库单据
    //出库单据(查看)
    ST_OUT_VW = "vrm2.st.out.vw",
    //出库单据(导出)
    ST_OUT_EX = "vrm2.st.out.ex",
    //出库单据(详情-返回)
    ST_OUT_BACK = "vrm2.st.out.back",

    //入库单据
    //入库单据(查看)
    ST_IN_VW = "vrm2.st.in.vw",
    //入库单据(导出)
    ST_IN_EX = "vrm2.st.in.ex",
    //入库单据(详情-返回)
    ST_IN_BACK = "vrm2.st.in.back",

    /*fms*/
    //客户账户管理 （查看）
    ACC_C_VW = "vrm2.ac.c.vw",
    //客户账户管理 （账户初始化）
    ACC_C_INIT = "vrm2.ac.c.init",
    //客户账户管理 （同步）
    ACC_C_ASYNC = "vrm2.ac.c.async",

    //客户账户管理详情 （账户信息）
    ACC_C_VW_AC = "vrm2.ac.c.vw.ac",
    //客户账户管理详情 （账户信息-开户）
    ACC_C_VW_AC_INIT = "vrm2.ac.c.vw.ac.init",
    //客户账户管理详情 （账户信息-调额）
    ACC_C_VW_AC_ADJ = "vrm2.ac.c.vw.ac.adj",
    //客户账户管理详情 （账户信息-充值）
    ACC_C_VW_AC_CHARG = "vrm2.ac.c.vw.ac.charg",
    //客户账户管理详情 （账户信息-转账）
    ACC_C_VW_AC_TRANS = "vrm2.ac.c.vw.ac.trans",
    //客户账户管理详情 （账户信息-核销账单）
    ACC_C_VW_AC_W_OFF = "vrm2.ac.c.vw.ac.w-off",
    //客户账户管理详情 （账户信息-启用禁用）
    ACC_C_VW_AC_DISABLE = "vrm2.ac.c.vw.ac.disable",

    //客户账户管理详情 （调额记录）
    ACC_C_VW_ADJ = "vrm2.ac.c.vw.adj",
    //客户账户管理详情 （调额记录-审核）
    ACC_C_VW_ADJ_AUDIT = "vrm2.ac.c.vw.adj.audit",

    //客户账户管理详情 （充值记录）
    ACC_C_VW_CHARG = "vrm2.ac.c.vw.charg",
    //客户账户管理详情 （充值记录-审核）
    ACC_C_VW_CHARG_AUDIT = "vrm2.ac.c.vw.charg.audit",

    //客户账户管理详情 （转账记录）
    ACC_C_VW_TRANS = "vrm2.ac.c.vw.trans",

    //客户账户管理详情 （账单信息）
    ACC_C_VW_BILL = "vrm2.ac.c.vw.bill",
    //客户账户管理详情 （账单信息-核销）
    ACC_C_VW_BILL_W_OFF = "vrm2.ac.c.vw.bill.w-off",
    //客户账户管理详情 （账单信息-批量核销）
    ACC_C_VW_BILL_W_OFF_BATCH = "vrm2.ac.c.vw.bill.w-off-batch",

    //客户账户管理详情 （核销记录）
    ACC_C_VW_W_OFF = "vrm2.ac.c.vw.w-off",
    //客户账户管理详情 （操作日志）
    ACC_C_VW_LOG = "vrm2.ac.c.vw.log",

    //供应商账户管理 （查看）
    ACC_S_VW = "vrm2.data.s.vw1",
    //供应商账户管理 （账户初始化）
    ACC_S_INIT = "vrm2.ac.s.init",
    //供应商账户管理 （同步）
    ACC_S_ASYNC = "vrm2.ac.s.async",

    //供应商账户管理详情 （账户信息）
    ACC_S_VW_AC = "vrm2.ac.s.vw.ac",
    //供应商账户管理详情 （账户信息-开户）
    ACC_S_VW_AC_INIT = "vrm2.ac.s.vw.ac.init",
    //供应商账户管理详情 （账户信息-调额）
    ACC_S_VW_AC_ADJ = "vrm2.ac.s.vw.ac.adj",
    //供应商账户管理详情 （账户信息-充值）
    ACC_S_VW_AC_CHARG = "vrm2.ac.s.vw.ac.charg",
    //供应商账户管理详情 （账户信息-转账）
    ACC_S_VW_AC_TRANS = "vrm2.ac.s.vw.ac.trans",
    //供应商账户管理详情 （账户信息-核销账单）
    ACC_S_VW_AC_W_OFF = "vrm2.ac.s.vw.ac.w-off",
    //供应商账户管理详情 （账户信息-批量核销）
    ACC_S_VW_AC_W_OFF_BATCH = "vrm2.ac.s.vw.ac.w-off-batch",
    //供应商账户管理详情 （账户信息-启用禁用）
    ACC_S_VW_AC_DISABLE = "vrm2.ac.s.vw.ac.disable",

    //供应商账户管理详情 （调额记录）
    ACC_S_VW_ADJ = "vrm2.ac.s.vw.adj",
    //供应商账户管理详情 （调额记录-审核）
    ACC_S_VW_ADJ_AUDIT = "vrm2.ac.s.vw.adj.audit",

    //供应商账户管理详情 （充值记录）
    ACC_S_VW_CHARG = "vrm2.ac.s.vw.charg",
    //供应商账户管理详情 （充值记录-审核）
    ACC_S_VW_CHARG_AUDIT = "vrm2.ac.s.vw.charg.audit",
    //供应商账户管理详情 （转账记录）
    ACC_S_VW_TRANS = "vrm2.ac.s.vw.trans",

    //供应商账户管理详情 （账单信息）
    ACC_S_VW_BILL = "vrm2.ac.s.vw.bill",
    //供应商账户管理详情 （账单信息-核销）
    ACC_S_VW_BILL_W_OFF = "vrm2.ac.s.vw.bill.w-off",

    //供应商账户管理详情 （核销记录）
    ACC_S_VW_W_OFF = "vrm2.ac.s.vw.w-off",
    //供应商账户管理详情 （操作日志）
    ACC_S_VW_LOG = "vrm2.ac.s.vw.log",

    //客户账单管理-导出
    BILL_C_EXS = "vrm2.biil.c.ex",
    //客户账户管理-账单信息-导出
    ACC_BILL_C_EX = "vrm2.ac.c.vw.bill.ex",
    //供应商账单管理-导出
    BILL_S_EX = "vrm2.biil.s.ex",
    //供应商账户管理-账单信息-导出
    ACC_BILL_S_EX = "vrm2.ac.s.vw.bill.ex",

    //客户信息管理(查看)
    DATA_C_VW = "vrm2.data.c.vw",
    //客户信息管理(同步)
    DATA_C_SYNC = "vrm2.data.c.sync",

    //供应商管理(查看)
    DATA_S_VW1 = "vrm2.data.s.vw1",
    //供应商管理(同步)
    DATA_S_SYNC = "vrm2.data.s.sync",

    //统计分析
    //应收报表（导出）
    STATIST_RECEIVABLE_EXPORT = "vrm2.statist.receivable.export",
    //销售报表（导出）
    STATIST_SALE_EXPORT = "vrm2.statist.sale.export",
    //收入汇总报表(导出)
    STATIST_INCOME_EXPORT = "vrm2.statist.income.export",

    //调入单编辑、
    P_DR_ED = "vrm2.p.dr.ed",
    //调入单请调、
    P_DR_AD_APPLY = "vrm2.p.dr.ad.apply",
    //调入单-删除商品、
    P_DR_AD_DEL_M = "vrm2.p.dr.ad.del-m",
    //调入单-调入、
    P_DR_ED_DR = "vrm2.p.dr.ed.dr",
    //调入单-导入明细、
    P_DR_AD_IM = "vrm2.p.dr.ad.im",
    //调入单-新增、
    P_DR_AD = "vrm2.p.dr.ad",
    //调入单-新增商品、
    P_DR_AD_ADD_M = "vrm2.p.dr.ad.add-m",
    //调入单-导出、
    P_DR_EX = "vrm2.p.dr.ex",
    //调入单-导出明细、
    P_DR_ED_EX = "vrm2.p.dr.ed.ex",
    //调入单-打印、
    P_DR_ED_PRINT = "vrm2.p.dr.ed.print",
    //调入单-下载模板、
    P_DR_AD_DLOAD = "vrm2.p.dr.ad.dload",
    //调入单（添加临时货位）
    P_DR_TEMP_SHELF = "vrm2.p.dr.ed.temp-shelf",
    //调出单-删除商品、
    S_DC_ED_DEL_M = "vrm2.s.dc.ed.del-m",
    //调出单-导入明细、
    S_DC_ED_IM = "vrm2.s.dc.ed.im",
    //调出单-导出、
    S_DC_EX = "vrm2.s.dc.ex",
    //调出单-打印、
    S_DC_ED_PRINT = "vrm2.s.dc.ed.print",
    //调出单-调出、
    S_DC_ED_DC = "vrm2.s.dc.ed.dc",
    //调出单编辑-保存、
    S_DC_ED_SAVE = "vrm2.s.dc.ed.save",
    //调出单新增-保存、
    S_DC_AD_SAVE = "vrm2.s.dc.ad.save",
    //调出单-新增商品、
    S_DC_ED_ADD_M = "vrm2.s.dc.ed.add-m",
    //调出单-驳回、
    S_DC_ED_REJECT = "vrm2.s.dc.ed.reject",
    //调出单-新增、
    S_DC_AD = "vrm2.s.dc.ad",
    //调出单编辑、
    S_DC_ED = "vrm2.s.dc.ed",
    //调出单-导出明细、
    S_DC_ED_EX = "vrm2.s.dc.ed.ex",
    //调出单-下载模板、
    S_DC_ED_DLOAD = "vrm2.s.dc.ed.dload",

    //调拨统计（导出）
    ST_DB_EX = "vrm2.st.db.ex",
    // 内部核算单位(新增)
    DATA_ACCUNIT_AD = "vrm2.data.accUnit.ad",
    // 内部核算单位(编辑)
    DATA_ACCUNIT_ED = "vrm2.data.accUnit.ed",
    // 内部核算单位(导出)
    DATA_ACCUNIT_EX = "vrm2.data.accUnit.ex",

    // 内部核算单位(新增-保存)
    DATA_ACCUNIT_AD_SAVE = "vrm2.data.accUnit.ad.save",
    // 内部核算单位(编辑-保存)
    DATA_ACCUNIT_ED_SAVE = "vrm2.data.accUnit.ed.save",
    //内部调拨单（申请）
    ACC_INTERNAL_APPLY = "vrm2.ac.internal.apply",
    //内部调拨单（查看）
    ACC_INTERNAL_VW = "vrm2.ac.internal.vw",
    //内部调拨单（申请-申请）
    ACC_INTERNAL_APPLY_APPLY = "vrm2.ac.internal.apply.apply",
    //内部调拨单（申请-保存）
    ACC_INTERNAL_APPLY_SAVE = "vrm2.ac.internal.apply.save",
    //内部调拨单（申请-确认）
    ACC_INTERNAL_APPLY_CONFIRM = "vrm2.ac.internal.apply.confirm",
    //内部调拨单（申请-驳回）
    ACC_INTERNAL_APPLY_REJECT = "vrm2.ac.internal.apply.reject",

    //采购单报表
    STT_PL_EX = "vrm2.stt.pl.ex",
    //采购单明细表
    STT_P_EX = "vrm2.stt.p.ex",
    //销售单明细表
    STT_S_EX = "vrm2.stt.s.ex",
    //销售单报表-导出
    STT_SL_EX = "vrm2.stt.sl.ex",
    //采购订单台账-导出
    STT_OR_EX = "vrm2.stt.or.ex",
    //预约单(详情-下载模板)     
    AP_ED_DLOAD = "vrm2.ap.ed.dload",
    //预约单(详情-导入)
    AP_ED_IM = "vrm2.ap.ed.im",
    //维修单(详情-下载模板)     M
    M_ED_DLOAD = "vrm2.m.ed.dload",
    //维修单(详情-导入)
    M_ED_IM = "vrm2.m.ed.im",
    //车辆维修历史(详情)
    STT_RH_VW = "vrm2.stt.rh.vw",
    //车辆维修历史-导出
    STT_RH_EX = "vrm2.stt.rh.ex",

    //维修模板-新增
    VRM2_DATA_REPAIRTEMPLATE_ADD = "vrm2.data.repairTemplate.add",
    //维修模板-编辑
    VRM2_DATA_REPAIRTEMPLATE_EDIT = "vrm2.data.repairTemplate.edit",
    //维修模板-查看
    VRM2_DATA_REPAIRTEMPLATE_LOOK = "vrm2.data.repairTemplate.look",
    //维修模板-下载模板
    VRM2_DATA_REPAIRTEMPLATE_MODELEXPORT = "vrm2.data.repairTemplate.modelExport",
    //维修模板-导入
    VRM2_DATA_REPAIRTEMPLATE_IMPORT = "vrm2.data.repairTemplate.import",
    //维修模板-导出
    VRM2_DATA_REPAIRTEMPLATE_EXPORT = "vrm2.data.repairTemplate.export",
    //维修模板-详情保存
    VRM2_DATA_REPAIRTEMPLATE_DE_SAVE = "vrm2.data.repairTemplate.de.save",
    //维修模板-详情新增项目
    VRM2_DATA_REPAIRTEMPLATE_DE_ADDITEM = "vrm2.data.repairTemplate.de.addItem",
    //维修模板-详情删除项目
    VRM2_DATA_REPAIRTEMPLATE_DE_RMITEM = "vrm2.data.repairTemplate.de.rmItem",
    //维修模板-详情新增商品
    VRM2_DATA_REPAIRTEMPLATE_DE_ADDGOOD = "vrm2.data.repairTemplate.de.addGood",
    //维修模板-详情删除商品
    VRM2_DATA_REPAIRTEMPLATE_DE_RMGOOD = "vrm2.data.repairTemplate.de.rmGood",
    //维修模板-详情商品项目导入
    VRM2_DATA_REPAIRTEMPLATE_DE_DETIALIMPORT = "vrm2.data.repairTemplate.de.detialImport",
    //维修模板-详情商品下载模板
    VRM2_DATA_REPAIRTEMPLATE_DE_DETIALEXPORT = "vrm2.data.repairTemplate.de.detialexport",


    //统计报表-符合条件生成询价单
    VRM2_STT_PL_GENERATEINQUIRYSHEET = 'vrm2.stt.pl.GenerateInquirySheet',
    //统计报表-导出
    VRM2_STT_PL_GENERATEEXPORT = 'vrm2.stt.pl.GenerateExport',
    //	进销存报表-进销存统计报表
    VRM2_STT_JXC_STATISTICSREPORT = 'vrm2.stt.jxc.statisticsReport',
    //进销存报表-商品明细账导出
    VRM2_STT_JXC_GOODLEDGER_EX = 'vrm2.stt.jxc.goodledger.ex',
    //进销存报表-导出
    VRM2_STT_JXC_EX = 'vrm2.stt.jxc.ex',
    //进销存报表-商品明细账
    VRM2_STT_JXC_GOODLEDGER = 'vrm2.stt.jxc.goodledger',
    //采购订单台账-导出	
    VRM2_STT_OR_EX = 'vrm2.stt.or.ex',
    //车辆维修历史-导出
    VRM2_STT_RH_EX = 'vrm2.stt.rh.ex',
    //工时统计-导出
    VRM2_STT_TIMETOTAL_EX = 'vrm2.stt.timeTotal.ex',


    //报修单-详情
    VRM2_REPORTREPAIRS_DETIAL = "vrm2.reportRepairs.detial",
    //报修单-详情-查看进度
    VRM2_REPORTREPAIRS_DETIALLOG = "vrm2.reportRepairs.detialLog",
    //报修单-导出
    VRM2_REPORTREPAIRS_EXPORT = 'vrm2.reportRepairs.export',
    //报修单-验收
    VRM2_REPORTREPAIRS_CHECK = "vrm2.reportRepairs.check",

    //外修单-详情
    VRM2_EXTERNALREPAIR_DETIAL = "vrm2.externalRepair.detial",
    //外修单-详情-查看进度
    VRM2_EXTERNALREPAIR_DETIALLOG = "vrm2.externalRepair.detialLog",
    //外修单-发布
    VRM2_EXTERNALREPAIR_PUBLISH = "vrm2.externalRepair.publish",
    //外修单-完工
    VRM2_EXTERNALREPAIR_COMPLETE = "vrm2.externalRepair.complete",
    //外修单-查看二维码
    VRM2_EXTERNALREPAIR_LOOKRCODE = "vrm2.externalRepair.lookRcode",
    //外修单-报价完成
    VRM2_EXTERNALREPAIR_QUOTATION = "vrm2.externalRepair.quotation",
    //外修单-导出
    VRM2_EXTERNALREPAIR_EXPORT = 'vrm2.externalRepair.export',
    //外修单-打印审批单
    VRM2_EXTERNALREPAIR_SPPRINT = 'vrm2.externalRepair.spPrint',
    //外修单-打印接车单
    VRM2_EXTERNALREPAIR_JCPRINT = 'vrm2.externalRepair.jcPrint',
    //外修单-打印竣工单
    VRM2_EXTERNALREPAIR_JGPRINT = 'vrm2.externalRepair.jgPrint',
    //外修单-修改报价
    VRM2_EXTERNALREPAIR_EDITPRICE = "vrm2.externalRepair.editPrice",
    //维修单-详情
    VRM2_REPAIR_DETIAL = "vrm2.Repair.detial",
    //维修单-详情-查看进度
    VRM2_REPAIR_DETIALLOG = "vrm2.Repair.detialLog",

    //维修单-转外修
    VRM2_REPAIR_TRANSFEROUT = "vrm2.Repair.transferOut",
    //外修单-报价历史
    VRM2_EXTERNALREPAIR_HISTORYPRICE = "vrm2.externalRepair.historyPrice",
    //维修单-出库台账导出
    VRM2_REPAIR_EXPORTOFOUTBOUNDLEDGE = "vrm2.externalRepair.ExportOfOutboundLedge",
    //维修单-主单导出
    VRM2_REPAIR_MAINREPAIRFORMEXPORT = "vrm2.externalRepair.mainRepairFormExport",
    //
    //预约-导出(无单价）
    VRM2_AP_EXNOPRICE = "vrm2.ap.exnoprice",
    //维修单-导出(无单价）
    VRM2_REPAIR_EXNOPRICE = "vrm2.Repair.exnoprice",
}